import React from 'react'
import PropTypes from 'prop-types'
import { useHandler, useIsFormSectionDisabled, useFormSectionPath, useFormState } from 'src/hooks'
import { Checkbox } from '../inputs'

/**
 * A special field for handling arrays of values
 * The content of the array depends of the checked state of the rendered checkboxes
 * When a checkbox is checked, its value is pushed in the array
 * When a checkbox is unchecked, its value is removed from the array
 *
 */
export default function CheckboxListField({ name, component: Component, value, disabled, ...props }) {
  // get relative path
  const path = useFormSectionPath(name)

  // get field value
  const [array, setArray] = useFormState(path, [])

  // get checkbox state
  const checked = React.useMemo(() => array.includes(value), [value, array])

  // create field onChange handler
  const onChange = useHandler(checked => setArray(checked ? [...array, value] : array.filter(v => v !== value)))

  // render input
  return (
    <Component
      value={value}
      onChange={onChange}
      checked={checked}
      disabled={useIsFormSectionDisabled() || disabled}
      {...props}
    />
  )
}

CheckboxListField.defaultProps = {
  component: Checkbox,
}

CheckboxListField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  component: PropTypes.elementType,
  disabled: PropTypes.bool,
}
